import { Type } from 'class-transformer';
import { WorkAuthorizationFileInfoResultDto } from './work-authorization-file-info-result-dto';

export class WorkOrderManageWorkAuthorizationResultDto {
    communityName: string;
    communityId: number;
    workOrderId: number;
    vendorName: string;
    vendorEstimate: number;
    hasNotes: boolean;

    @Type(() => WorkAuthorizationFileInfoResultDto)
    files: Array<WorkAuthorizationFileInfoResultDto>;
}
